module.exports = __webpack_public_path__ + "img/firma_compuesta.61c108ba.svg";